import {
  ExtendedNamedAttachmentModel,
  ServiceAgreementTypeEnum,
} from 'api/backofficeApiClient';
import { FileLoadingStatus, FileLoadStatus } from './DownloadClientAgreement';

const getAgreementButtonLabel = (
  agreementDetailsType?: ServiceAgreementTypeEnum,
) => {
  switch (agreementDetailsType) {
    case ServiceAgreementTypeEnum.MemberAgreement:
      return 'Download member agreement';

    case ServiceAgreementTypeEnum.ClientAgreement:
    default:
      return 'Download customer agreement';
  }
};

const updateFileStatus =
  (status: FileLoadingStatus, fileKeys: string[]) =>
  (prevState: FileLoadStatus[]) => {
    return prevState?.map((file) =>
      fileKeys.includes(file.fileKey) ? { ...file, status } : file,
    );
  };

const mapAgreementFilesLoadStatus = (
  responseFiles: ExtendedNamedAttachmentModel[] = [],
): FileLoadStatus[] => {
  if (!responseFiles?.length) return [];

  return responseFiles.map((file) => ({
    status: FileLoadingStatus.Default,
    fileKey: file.fileKey || '',
    fileName: file.fileName || '',
  }));
};
export {
  getAgreementButtonLabel,
  updateFileStatus,
  mapAgreementFilesLoadStatus,
};
